import { render, staticRenderFns } from "./EmpiPixModal.vue?vue&type=template&id=c36dbe02&scoped=true"
import script from "./EmpiPixModal.vue?vue&type=script&lang=js"
export * from "./EmpiPixModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36dbe02",
  null
  
)

export default component.exports